module.exports = __webpack_public_path__ + "static/media/cancel-icon.9ad4f0a2.svg";